var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "选择直播间",
        width: "1200px",
        loading: _vm.sureLoading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "selectLiveRoomScript" }, [
        _c(
          "div",
          { staticClass: "filterHeader" },
          [
            _c("span", { staticClass: "formLabel" }, [_vm._v("直播间名称")]),
            _c("el-input", {
              staticClass: "m-r-10",
              staticStyle: { width: "240px" },
              attrs: {
                size: "small",
                placeholder: "请输入直播间名称",
                clearable: "",
              },
              on: { clear: _vm.searchFn },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchFn.apply(null, arguments)
                },
              },
              model: {
                value: _vm.search.liveRoomName,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.search,
                    "liveRoomName",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "search.liveRoomName",
              },
            }),
            _c("span", { staticClass: "formLabel" }, [_vm._v("开播时间")]),
            _c("el-date-picker", {
              staticClass: "input-with-time",
              attrs: {
                size: "small",
                type: "daterange",
                "value-format": "yyyy-MM-dd",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "unlink-panels": true,
              },
              on: { change: _vm.handleClickSearch },
              model: {
                value: _vm.search.time.value,
                callback: function ($$v) {
                  _vm.$set(_vm.search.time, "value", $$v)
                },
                expression: "search.time.value",
              },
            }),
            _c(
              "el-button",
              {
                staticClass: "m-l-10",
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.searchFn },
              },
              [_vm._v("搜索")]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "myTable",
          },
          [
            _c(
              "el-table",
              {
                attrs: {
                  height: "502",
                  "header-cell-style": { background: "#F3F3F3" },
                  data: _vm.list,
                },
                on: { "row-click": _vm.rowClick },
              },
              [
                _c("el-table-column", {
                  attrs: { width: "80", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-checkbox", {
                            attrs: {
                              value: _vm.selectIdsList.includes(row.id),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.rowClick(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "code", label: "直播间ID", width: "200" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "直播间名称",
                    prop: "name",
                    "min-width": "190px",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "出场顺序", prop: "appearSequence" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "直播模式",
                    prop: "liveModel",
                    "min-width": "152px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "liveMode",
                              class: `liveMode${row.liveModel}`,
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      "class-name": "liveModeicon",
                                      "icon-class": _vm.getOptionsValueByKey(
                                        "value",
                                        "icon",
                                        row.liveModel,
                                        _vm.liveModeOption
                                      ),
                                    },
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("getOptionsValue")(
                                        row.liveModel,
                                        _vm.liveModeOption
                                      )
                                    ) + " "
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "开播时间",
                    prop: "startTime",
                    "min-width": "152px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .moment(row.startTime)
                                  .format("YYYY-MM-DD HH:mm:ss")
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "创建人",
                    prop: "createUserName",
                    "min-width": "114px",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("div", { staticClass: "tipsError" }, [
                  _c("span", { staticClass: "tips" }, [
                    _vm._v("已选" + _vm._s(_vm.selectList.length) + "项"),
                  ]),
                  _vm.selectList.length > 10
                    ? _c("span", { staticClass: "m-l-10" }, [
                        _vm._v("你勾选的直播间超出10个，建议重新选择。"),
                      ])
                    : _vm._e(),
                ]),
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                    "pager-count": 5,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "div",
          { staticClass: "ss-material-box-bottom" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.sure },
              },
              [_vm._v("确认")]
            ),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.closeFn } },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }